<template>
  <v-app>
    <router-view></router-view>
    <notifications
      group="app"
      ignoreDuplicates
      position="top center"
      width="300px"
      :duration="-1"
      :speed="500"
      >group="custom-style"
      <template slot="body" slot-scope="props">
        <div
          :class="'notification n-light' + (props.item.type || '')"
          @click="closeEvent(props)"
        >
          <div
            v-if="props.item.title"
            class="notification-title"
            v-html="props.item.title"
          ></div>
          <hr />

          <div class="notification-content" v-html="props.item.text"></div>
          <hr />
          <div
            class="notification-content"
            v-html="'From:  ' + props.item.data.from"
          ></div>
          <div
            class="notification-content"
            v-html="'Date:  ' + props.item.data.date"
          ></div>
        </div>
      </template>
    </notifications>
    <notifications
      group="notify"
      ignoreDuplicates
      position="bottom right"
      :duration="7000"
      :speed="500"
    />
  </v-app>
</template>

<script>
// import Login from './components/Login';
//import Calendar from './components/Calendar';
import Vue from "vue";
import api from "./api";
const moment = require("moment");
import notifySound from "./assets/notify.wav";
export default {
  name: "App",
  data() {
    return {
      playNotify: new Audio(notifySound),
    };
  },
  beforeMount() {
    return api.checkLogin(this);
  },
  computed: {
    getNotify() {
      return this.$store.state.data.notify;
    },
  },
  watch: {
    getNotify: function (newData) {
      var setRead = [];
      var needSound = false;
      var image = require("./assets/logoblue.png");
      newData.forEach((notify) => {
        Vue.notify({
          group: notify.type,
          title: notify.title,
          text: notify.text,
          data: {
            appid: notify.id,
            from: notify.fromname,
            date: moment
              .utc(notify.created)
              .local()
              .format("MM/DD/YYYY hh:mm A"),
          },
        });
        this.winNotify(notify.title, { body: notify.text, icon: image });
        if (notify.type == "notify") {
          setRead.push(notify.id);
        }
        if (this.$store.state.notifyIds.indexOf(notify.id) == -1) {
          needSound = true;
          this.$store.state.notifyIds.push(notify.id);
        }
      });
      if (needSound) {
        this.playNotify.play();
      }
      if (setRead.length > 0) {
        api.setRead(setRead);
      }
    },
  },
  methods: {
    closeEvent(props) {
      api.setRead([props.item.data.appid]);
      props.close();
    },
    winNotify(title, body) {
      if (!("Notification" in window)) {
        return
      } else if (Notification.permission === "granted") {
        this.sendNotify(title, body);
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission(function (permission) {
          if (permission === "granted") {
            this.sendNotify(title, body);
          }
        });
      }
    },
    sendNotify(title, body) {
      var notification = new Notification(title, body);
      return notification
    },
  },
};
</script>

<style>
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #1976d2; 
}
.notification.n-light {
  margin: 10px;
  margin-bottom: 0;

  border-radius: 3px;
  font-size: 13px;

  padding: 10px 20px;

  color: #495061;
  background: #eaf4fe;

  border: 1px solid #d4e8fd;
}
.notification.n-light .notification-title {
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 10px;
  color: #2589f3;
}
</style>
